import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'mnc-notes-samples',
  template: '<router-outlet>',
  standalone: true,
  imports:[
    RouterOutlet
  ]
})
export class SamplesComponent {
}
